module.exports = __webpack_public_path__ + "static/shoot-958b78a3e758ad5aba78d64a83767d4d.jpeg";